/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalSpendCloudAndPlatform extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalSpendCloudAndPlatform");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalSpendCloudAndPlatform.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalSpendCloudAndPlatform>): BillingRuleAllocationProportionalSpendCloudAndPlatform {
        let obj = Object.assign(new BillingRuleAllocationProportionalSpendCloudAndPlatform(), model);
        BillingRuleAllocationProportionalSpendCloudAndPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalSpendCloudAndPlatform>): BillingRuleAllocationProportionalSpendCloudAndPlatform {
        if (!model) return null;
        return BillingRuleAllocationProportionalSpendCloudAndPlatform.newInstance(<BillingRuleAllocationProportionalSpendCloudAndPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalSpendCloudAndPlatform) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalSpendCloudAndPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalSpendCloudAndPlatform): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalSpendCloudAndPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
